import React from 'react';
import { Link } from 'react-router-dom';
import { 
    GithubOutlined, 
    LinkedinOutlined, 
    TwitterOutlined, 
    FacebookOutlined,
    InstagramOutlined,
    YoutubeOutlined,
    FileTextOutlined
} from '@ant-design/icons';
import { useCustomization } from '../../contexts/CustomizationContext';
import '../../styles/layout/Footer.css';

const Footer = () => {
    const { customization } = useCustomization();
    const currentYear = new Date().getFullYear();
    
    // Check if any social media platforms are configured
    const hasSocialMedia = customization.contact_github || 
                          customization.contact_linkedin || 
                          customization.contact_twitter || 
                          customization.contact_facebook || 
                          customization.contact_instagram || 
                          customization.contact_youtube || 
                          customization.contact_blog;
    
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-sections">
                    {hasSocialMedia && (
                        <div className="footer-section">
                            <h4>Connect With Us</h4>
                            <div className="social-links">
                            {customization.contact_github && (
                                <a href={customization.contact_github} target="_blank" rel="noopener noreferrer">
                                    <GithubOutlined className="social-icon" />
                                </a>
                            )}
                            {customization.contact_linkedin && (
                                <a href={customization.contact_linkedin} target="_blank" rel="noopener noreferrer">
                                    <LinkedinOutlined className="social-icon" />
                                </a>
                            )}
                            {customization.contact_twitter && (
                                <a href={customization.contact_twitter} target="_blank" rel="noopener noreferrer">
                                    <TwitterOutlined className="social-icon" />
                                </a>
                            )}
                            {customization.contact_facebook && (
                                <a href={customization.contact_facebook} target="_blank" rel="noopener noreferrer">
                                    <FacebookOutlined className="social-icon" />
                                </a>
                            )}
                            {customization.contact_instagram && (
                                <a href={customization.contact_instagram} target="_blank" rel="noopener noreferrer">
                                    <InstagramOutlined className="social-icon" />
                                </a>
                            )}
                            {customization.contact_youtube && (
                                <a href={customization.contact_youtube} target="_blank" rel="noopener noreferrer">
                                    <YoutubeOutlined className="social-icon" />
                                </a>
                            )}
                            {customization.contact_blog && (
                                <a href={customization.contact_blog} target="_blank" rel="noopener noreferrer">
                                    <FileTextOutlined className="social-icon" />
                                </a>
                            )}
                            </div>
                        </div>
                    )}
                    <div className="footer-section">
                        <h4>Support</h4>
                        <Link to="/help">Help Center</Link>
                        <Link to="/terms">Terms of Service</Link>
                        <Link to="/security">Security</Link>
                    </div>
                    <div className="footer-section">
                        <h4>Contact</h4>
                        <a href={`mailto:${customization.contact_email}`}>{customization.contact_email}</a>
                        {customization.company_website && (
                            <a href={customization.company_website} target="_blank" rel="noopener noreferrer">
                                {customization.company_website}
                            </a>
                        )}
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>© {currentYear} {customization.company_name}. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 